import type { PortalCatalog } from "./en";

/** نصوص بوابة الاستشارات العامة (مساحة الأسماء `portal`) بالعربية الفصحى. */
const ar: PortalCatalog = {
  nav: { home: "الرئيسية", registry: "سجل السياسات", consultations: "الاستشارات", verify: "التحقق من وثيقة", about: "عن الاستشارات العامة" },
  uaePass: "تسجيل الدخول باستخدام الهوية الرقمية (UAE PASS)",
  uaePassSoon: "ستُتاح خدمة تسجيل الدخول بالهوية الرقمية (UAE PASS) قريباً. ويمكنكم المشاركة في الاستشارات دون تسجيل الدخول.",
  footer: "تساعد مشاركتكم الجهات الاتحادية على تصميم سياسات أفضل. وتُعالَج البيانات الشخصية وفق المرسوم بقانون اتحادي رقم (45) لسنة 2021 بشأن حماية البيانات الشخصية.",
  home: {
    eyebrow: "حكومة الإمارات العربية المتحدة",
    title: "سياسات اتحادية متاحة للجميع",
    intro: "تصفّحوا السجل الوطني للسياسات الاتحادية المعتمدة، واطّلعوا على المسودات المطروحة للاستشارة العامة وأبدوا آراءكم للوزارة المعنية، أو تحقّقوا من صحة شهادة صادرة عن أكاديمية السياسات.",
    browseRegistry: "تصفّح السجل",
    seeConsultations: "عرض الاستشارات المفتوحة",
    cards: {
      registry: { title: "السجل الوطني للسياسات", body: "السياسات والقوانين والقرارات الاتحادية المعتمدة، مع الجهة المسؤولة عنها وحالتها وتواريخها الرئيسية." },
      consultations: { title: "الاستشارات العامة", body: "اطّلعوا على مسودات السياسات وأرسلوا ملاحظاتكم قبل اعتمادها." },
      verify: { title: "التحقق من وثيقة", body: "تأكّدوا من أن شهادة أكاديمية السياسات أو ملف السياسة المختوم صحيح ولم يُعدَّل." },
    },
    openConsultations: "الاستشارات المفتوحة",
    allConsultations: "جميع الاستشارات",
    latest: "أحدث السياسات المنشورة",
    allRegistry: "السجل كاملاً",
  },
  list: {
    title: "الاستشارات العامة",
    description: "اطّلعوا على مسودات السياسات الاتحادية، وأبدوا آراءكم للوزارة المعنية قبل اعتمادها.",
    open: "الاستشارات المفتوحة",
    closesIn: "تنتهي {{relative}}",
    questions_one: "سؤال واحد",
    questions_other: "عدد الأسئلة: {{count}}",
    respond: "الاطلاع والمشاركة",
    emptyTitle: "لا توجد استشارات مفتوحة حالياً",
    emptyBody: "يُعلَن هنا عن الاستشارات الجديدة، فيُرجى المتابعة لاحقاً.",
  },
  detail: {
    back: "جميع الاستشارات",
    purpose: "الغرض من الاستشارة",
    policy: "السياسة",
    period: "مدة الاستشارة",
    summary: "ملخص المسودة",
    documents: "وثائق الاستشارة",
    noDocuments: "لا توجد وثائق مرفقة بهذه الاستشارة.",
    respondTitle: "مشاركتكم",
    respondIntro: "لا يلزم سوى موقفكم العام وملاحظاتكم وموافقتكم، ويمكنكم المشاركة دون ذكر الاسم.",
    name: "الاسم (اختياري)",
    organisation: "الجهة (اختياري)",
    organisationHint: "إذا كانت مشاركتكم نيابةً عن شركة أو جمعية أو جهة أخرى.",
    stance: "الموقف العام",
    stances: {
      support: "أؤيد المقترح",
      support_with_changes: "أؤيده مع إجراء تعديلات",
      oppose: "أعارض المقترح",
      neutral: "ليس لدي موقف عام",
    },
    clause: "الجزء الذي تعلّقون عليه من المسودة (اختياري)",
    clauseHint: "اختاروا بنداً إذا كانت ملاحظاتكم تخص جزءاً محدداً من المسودة.",
    clauseNone: "المسودة بأكملها",
    questions: "أسئلة الوزارة",
    body: "ملاحظاتكم",
    bodyHint: "وضّحوا موقفكم وأي تعديلات تقترحونها.",
    bodyHintQuestions: "أي ملاحظات إضافية. ويلزم ملء هذا الحقل إذا لم تُجيبوا عن أي سؤال.",
    bodyRequired: "يُرجى كتابة ملاحظاتكم، أو الإجابة عن سؤال واحد على الأقل.",
    consent: "أوافق على تحليل مشاركتي ونشرها في صورة ملخص دون ذكر اسمي.",
    privacyNote: "لا نطلب عنوان بريدكم الإلكتروني. ولا تطّلع على الاسم والجهة إلا الوزارة المعنية، ولا يُنشران مطلقاً.",
    submit: "إرسال المشاركة",
    submitting: "جارٍ الإرسال…",
    stanceRequired: "يُرجى اختيار موقفكم العام.",
    consentRequired: "يلزم الحصول على موافقتكم لإرسال المشاركة.",
    thanksTitle: "شكراً لمشاركتكم",
    thanksBody: "استلمت الوزارة المعنية مشاركتكم. وسيُنشر ملخص لجميع المشاركات بعد انتهاء مدة الاستشارة.",
    closed: "انتهت مدة هذه الاستشارة ولم تعد تستقبل المشاركات.",
    notYetOpen: "تبدأ هذه الاستشارة في {{date}}. ويمكنكم الاطلاع على المسودة الآن والمشاركة عند بدئها.",
    notFoundTitle: "الاستشارة غير موجودة",
    notFoundBody: "قد تكون مدة الاستشارة انتهت، أو يكون الرابط غير صحيح.",
    failureTitle: {
      rateLimited: "يُرجى الانتظار بضع دقائق",
      closed: "لم تعد المشاركات مقبولة",
      unavailable: "الخدمة غير متاحة",
      server: "يُرجى مراجعة مشاركتكم",
      generic: "لم تُرسَل مشاركتكم",
    },
    failure: {
      rateLimited: "أُرسلت عدة مشاركات من اتصالكم خلال وقت قصير. وما زال نصكم محفوظاً هنا، فيُرجى المحاولة مجدداً بعد نحو عشر دقائق.",
      closed: "انتهت مدة هذه الاستشارة أو لم تبدأ بعد، لذا تعذّر قبول مشاركتكم.",
      unavailable: "تعذّر الوصول إلى خدمة الاستشارات. وما زال نصكم محفوظاً هنا، فيُرجى التحقق من اتصالكم والمحاولة مجدداً.",
      server: "تحتاج بعض المعلومات في مشاركتكم إلى تصحيح.",
      generic: "حدث خطأ أثناء إرسال مشاركتكم. وما زال نصكم محفوظاً هنا، فيُرجى المحاولة مجدداً.",
    },
  },
  draft: {
    title: "المسودة المطروحة للاستشارة",
    showAll_one: "عرض المسودة كاملة (بند واحد)",
    showAll_other: "عرض المسودة كاملة (عدد البنود: {{count}})",
    showText_one: "عرض النص كاملاً (بند واحد)",
    showText_other: "عرض النص كاملاً (عدد البنود: {{count}})",
    showLess: "عرض أقل",
  },
  registry: {
    title: "السجل الوطني للسياسات",
    description: "السياسات الاتحادية التي اعتمدها مجلس الوزراء ونُشرت للجمهور، مع الوزارة المسؤولة عنها وتواريخها الرئيسية.",
    search: "البحث",
    searchPlaceholder: "العنوان أو الرمز أو كلمة مفتاحية",
    sector: "القطاع",
    allSectors: "جميع القطاعات",
    instrument: "نوع الأداة",
    allInstruments: "جميع الأنواع",
    owner: "الجهة المسؤولة",
    allOwners: "جميع الجهات",
    year: "السنة",
    allYears: "جميع السنوات",
    results_one: "سياسة واحدة",
    results_other: "عدد السياسات: {{total}}",
    resultsLoading: "جارٍ البحث في السجل…",
    emptyTitle: "لم تُنشر أي سياسات بعد",
    emptyBody: "تظهر هنا السياسات العامة المعتمدة فور نشرها.",
    noMatchTitle: "لا توجد سياسات مطابقة لبحثكم",
    noMatchBody: "جرّبوا كلمات أخرى أو أزيلوا أحد عوامل التصفية.",
    clear: "مسح البحث وعوامل التصفية",
    pagination: "صفحات السجل",
    previous: "السابق",
    next: "التالي",
    pageOf: "الصفحة {{page}} من {{pages}}",
    view: "عرض السياسة",
    effective: "سارية منذ {{date}}",
    publishedOn: "نُشرت في {{date}}",
    back: "سجل السياسات",
    notFoundTitle: "السياسة غير موجودة",
    notFoundBody: "قد لا تكون السياسة متاحة للجمهور، أو يكون الرابط غير صحيح.",
    text: "نص السياسة",
    noText: "لم يُنشر النص الكامل لهذه السياسة في السجل.",
    statuses: { published: "منشورة", in_force: "سارية", repealed: "ملغاة", expired: "منتهية السريان", superseded: "مستبدَلة" },
    field: {
      code: "الرمز المرجعي",
      owner: "الجهة المسؤولة",
      status: "الحالة",
      decision: "قرار مجلس الوزراء",
      effective: "تاريخ النفاذ",
      review: "موعد المراجعة المقبلة",
      sunset: "تاريخ انتهاء السريان",
      published: "تاريخ النشر في السجل",
    },
  },
  verify: {
    title: "التحقق من وثيقة",
    description: "تحقّقوا من أن شهادة أكاديمية السياسات، أو ملف السياسة المختوم عند تقديمه إلى الأمانة العامة لمجلس الوزراء، صحيح ولم يُعدَّل.",
    number: "رقم الشهادة أو الختم",
    hint: "مطبوع على الوثيقة، مثل GSOC-ACAD-2026-1A2B3C4D أو GSOC-SEAL-2026-1A2B3C4D5E.",
    submit: "التحقق",
    required: "يُرجى إدخال رقم الشهادة أو الختم.",
    format: "يجب أن يكون الرقم بصيغة مثل GSOC-ACAD-2026-1A2B3C4D أو GSOC-SEAL-2026-1A2B3C4D5E.",
    seal: {
      validTitle: "هذا الملف مختوم وسليم",
      validBody: "الختم مسجّل، ولم يتغيّر الملف منذ ختمه.",
      mismatchTitle: "هذه الوثيقة لا تطابق الختم",
      mismatchBody: "الختم مسجّل، لكن البصمة الموجودة على وثيقتكم مختلفة. ربما عُدِّلت الوثيقة بعد الختم، لذا يُرجى عدم الاعتماد عليها.",
      notFoundTitle: "لا يوجد ملف مختوم بهذا الرقم",
      notFoundBody: "تعذّر العثور على الختم {{number}}. يُرجى التحقق من الرقم والمحاولة مجدداً.",
      tamperedTitle: "تعذّر التحقق من هذا الختم",
      tamperedBody: "يوجد ختم بهذا الرقم، لكن الملف لم يعد مطابقاً لبصمته. يُرجى عدم الاعتماد عليه والتواصل مع الأمانة العامة لمجلس الوزراء.",
      confidential: "يعرض التحقق تفاصيل الختم فقط، ولا يعرض السياسة نفسها.",
      field: { number: "رقم الختم", ministry: "الجهة المقدِّمة", code: "مرجع السياسة", sealed: "تاريخ الختم", round: "جولة التقديم", status: "الحالة", document: "وثيقتكم", text: "نص السياسة" },
      match: {
        yes: "مطابقة للملف المختوم",
        textYes: "هو الإصدار الذي خُتم",
        no: "غير مطابقة",
        unchecked: "لم تُجرَ المقارنة. للمقارنة، امسحوا الرمز أو افتحوا الرابط المطبوع على الوثيقة.",
      },
      status: {
        received: "استلمته الأمانة العامة",
        inReview: "قيد المراجعة",
        challengeReview: "قيد المراجعة النقدية",
        endorsed: "مؤيَّد",
        endorsedWithConditions: "مؤيَّد بشروط",
        returned: "أُعيد إلى الوزارة",
        notSupported: "غير مؤيَّد",
        referredToRegLab: "أُحيل إلى مختبر التشريعات",
        onAgenda: "مُدرج على جدول أعمال مجلس الوزراء",
        decided: "صدر قرار مجلس الوزراء بشأنه",
      },
    },
    validTitle: "هذه الشهادة صحيحة",
    validBody: "أصدرتها أكاديمية السياسات، وبياناتها مطابقة للسجل.",
    notFoundTitle: "لا توجد شهادة بهذا الرقم",
    notFoundBody: "تعذّر العثور على الشهادة {{number}}. يُرجى التحقق من الرقم والمحاولة مجدداً.",
    tamperedTitle: "تعذّر التحقق من هذه الشهادة",
    tamperedBody: "توجد شهادة بهذا الرقم، لكن سجلها لم يعد مطابقاً لختمها الأمني. يُرجى عدم الاعتماد عليها والتواصل مع الجهة المُصدِرة.",
    field: { number: "رقم الشهادة", holder: "مُنحت إلى", path: "المسار التعليمي", ministry: "الجهة", issued: "تاريخ الإصدار" },
  },
  about: {
    title: "عن الاستشارات العامة",
    intro: "تُعدّ الاستشارة العامة جزءاً من دورة حياة السياسات الاتحادية. فقبل رفع السياسة إلى مجلس الوزراء، يجوز للوزارة المعنية نشر مسودتها ودعوة أفراد المجتمع وقطاع الأعمال ومؤسسات المجتمع المدني إلى إبداء ملاحظاتهم.",
    howTitle: "آلية المشاركة",
    how: [
      "تنشر الوزارة مسودة السياسة والأسئلة التي تطرحها وتاريخ انتهاء الاستشارة.",
      "تطّلعون على الوثائق وترسلون مشاركتكم، دون ذكر الاسم أو مع ذكر الاسم والجهة.",
      "بعد انتهاء الاستشارة، تحلل الوزارة جميع المشاركات وتنشر ملخصاً لما ورد فيها وكيفية تعاملها معه.",
    ],
    privacyTitle: "بياناتكم",
    privacy: "لا تُستخدم المشاركات إلا لتطوير السياسة المعنية، ولا نجمع عناوين البريد الإلكتروني، ولا تُنشر الأسماء مطلقاً. وتُعالَج البيانات وفق المرسوم بقانون اتحادي رقم (45) لسنة 2021 بشأن حماية البيانات الشخصية.",
  },
};

export default ar;
